// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox-m__container__jv-_h","checkmark":"checkbox-m__checkmark__1azwP"};